var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand-06",
    clipPath: "url(#clip0_112_220621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.50065 2.70371V1.08334M3.50065 1.08334L2.69046 1.89352M3.50065 1.08334L4.31083 1.89352M2.20435 4H0.583984M0.583984 4L1.39417 4.81018M0.583984 4L1.39417 3.18982M3.50065 5.29629V6.91666M3.50065 6.91666L4.31083 6.10648M3.50065 6.91666L2.69046 6.10648M4.79694 4H6.41731M6.41731 4L5.60712 3.18982M6.41731 4L5.60712 4.81018",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_220621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e6d5ffb92c774005f0a3d2224a7412c2.svg";
export { ForwardRef as ReactComponent };